module.exports = __webpack_public_path__ + "static/media/travis-ci.f985c1f1.svg";